/*
  INSERT INTO _20rs (
    _dmn, 
    _key, _vsn, _ltt, _fst, 
    _icn, _pfx,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    0, 
    1, 1, 1, 1, 
    '1', 'クライアントA',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );
*/

export const _20z = { // ドメイン // 履歴対象外
  _20r: { // ドメイン
    v0: {
      itlz: {
        _icn: '',
        _pfx: '',
      },
      fldz: {
        _icn: {
          pfx: 'ドメインID'
        },
        _pfx: {
          pfx: 'ドメイン名'
        }
      },
    },
  },
};
